module.exports = __webpack_public_path__ + "static/img/dehlogo.267ab07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dehlogo.png
// module id = gEls
// module chunks = 4